import { render, staticRenderFns } from "./subscriptions.component.vue?vue&type=template&id=47d5cf8e&scoped=true"
import script from "./subscriptions.component.vue?vue&type=script&lang=js"
export * from "./subscriptions.component.vue?vue&type=script&lang=js"
import style0 from "./subscriptions.component.vue?vue&type=style&index=0&id=47d5cf8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d5cf8e",
  null
  
)

export default component.exports